import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import LoggedOutRoutes from "./routes/loggedOutRoutes";
import LoggedInRoutes from "./routes/loggedInRoutes";
import MediumRoute from "./routes/mediumRoute";
import AdminRoutes from "./routes/adminRoute";
import MediumRouteApproved from "./routes/mediumRouteApproved";
import Layout from "./layout/layout";

import { setCredentials, setLoading, setRole, setUpAuthTrue } from "./reducer/auth/auth";

import "./App.css";
import i18n from "./i18n";
import { GridLoader } from "react-spinners";
import LoaderText from "./components/loader";

import ConfirAdvanceModal from "./pages/client/appointment/advanceappointment/confirmadvancemodal";
import CommonRoute from "./routes/commonroute";
import Help from "./components/help";
import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ClientRoute from "./routes/clientRoute";
import { fetchUser, getLimitunderMaintenance, logout } from "./services/auth";
import { setUser, setSaveTerms } from "./reducer/userSlice";
import { setHasRequest } from "./reducer/adminSlice";
import { userType } from "./utils/utils";
import { getAllRequests } from "./services/admin";
import { ADMIN } from "./utils/utils";
import Pusher from "pusher-js";
import MediumIntegrationRoute from "./routes/mediumIntegrationRoute";
import CheckTimeZone from "./components/checkTimeZone";
import { useNavigate, useSearchParams } from "react-router-dom";
import AlertPopUp from "./components/alertpopup";
import moment from "moment-timezone";
import { getTimezones } from "./services/uidata";
import { filterVisibleTimeZones } from "./utils/helpers";
import UpdateTimeZone from "./components/updateTimeZone";
import MediumOnBoardingRoute from "./routes/mediumOnBoarding";
import { changeOnlineStatusFunc } from "./commonfunctions";
import { ONBOARDING_HOST_STORAGE_KEY } from "./utils/onboardingBooking";
import { clearOrphanModalBackdrops } from "./utils/modalBackdrop";
import SupportIcon from "./components/supportIcon";
import Maintenance from "./components/maintenance";

// Long enough for the incoming screen to open its own modal before we sweep, short enough
// that a stranded backdrop is never something the user has time to click at.
const MODAL_BACKDROP_SWEEP_DELAY_MS = 400;

const App = (props) => {
 const location = useLocation();
  const { history } = props
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirect_to = searchParams.get("redirect_to")
  const from = searchParams.get("from");
  let currentPathname = window.location.pathname;
  let currentSearch = window.location.search

  const dispatch = useDispatch();
  const [underMaintenance, setunderMaintenance] = useState(0);
  const [newTimezoneData, setnewTimezoneData] = useState([]);

  const auth = useSelector((state) => state.auth);

  // The language switcher is for clients and mediums only, so admins (and any other
  // role) always see English even if this browser was last used in another language.
  useEffect(() => {
    if (auth.role && auth.role !== "client" && auth.role !== "medium" && i18n.language !== "en") {
      i18n.changeLanguage("en");
    }
  }, [auth.role]);
  const { status, medium_status, provider, is_first_appointment, timezone, onboarding_completed, banner_display, timezone_id, id, first_name, last_name, country, phone, agree_to_legal_terms_and_conditionss, opt_in_out, is_europe, is_starter, starter_redirect_url, is_questionnaire } = useSelector(
    (state) => state.user.user
  );
  const [hasProgressSection, setHasProgressSection] = useState(false);
  useEffect(() => {
    const pusher = new Pusher("823ab72ed6ecd563b8c8", {
      cluster: "ap2",
    });

    const channel = pusher.subscribe(
      "request-notification"
    );

    channel.bind(
      "App\\Events\\RequestNotification",
      (data) => {
        console.log("📢 Event received:aap", data);

        // ✅ backend says request exists
        if(data && data.isRequest == true){
          dispatch(setHasRequest(true));
        }else{
          dispatch(setHasRequest(false));
        }
     
      }
    );

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }, [dispatch]);

  useEffect(() => {
    // check on mount
    const checkProgress = () => {
      setHasProgressSection(!!document.querySelector(".progress-saction"));
    };

    checkProgress();

    // optional: observe DOM changes if progress-saction is added later
    const observer = new MutationObserver(checkProgress);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
  const underMaintenanceStatus = () => {
    getLimitunderMaintenance("under_maintenance")
      .then((data) => {
        if (data.data.data) {
          setunderMaintenance(parseInt(data.data.data.value));
        }
      })
      .catch(() => { });
  };
  if (window.self !== window.top) {
    document.body.classList.add("iframe-mode");
  }

  useEffect(() => {
    
    let token = localStorage.getItem('access_token')
    if (token && redirect_to && redirect_to == "medium-signup") {
      localStorage.setItem("medium-signup", redirect_to)
    }
    else {
      localStorage.removeItem("medium-signup")
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("redirect_to");
      window.history.replaceState({}, document.title, newUrl.href);
    }
  }, [])

  useEffect(() => {
    let token = localStorage.getItem('access_token')
    if (token && redirect_to && redirect_to == "starter-booking") {
      console.log("auth.role", auth.role, redirect_to);

      if (auth.role == "medium" || auth.role == "admin") {
        localStorage.setItem('dorefresh', 'no')
        logoutUser('/login?redirect_to=starter-booking');
      }
      else {
        localStorage.setItem("redirect_to", redirect_to)
      }
    }
  }, [auth.role])

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const path = location.pathname; // e.g. /interview-booking/gNhtiwj3kL

    // Check if path starts with /interview-booking/
    if (token && path.startsWith('/interview-booking/')) {
      // Prevent multiple logout/redirect loops by using a flag
      if (!sessionStorage.getItem("loggedOutForInterviewBooking")) {
        sessionStorage.setItem("loggedOutForInterviewBooking", "true");

        logout()
          .then(() => {
            localStorage.clear();
            sessionStorage.clear();

            // Redirect to the SAME URL (after logout)
            navigate(path, { replace: true });
          })
          .catch((err) => {
            console.error("Logout failed:", err);
          });
      }
    } else {
      // If user navigates elsewhere, clear the flag so this can run again if needed
      sessionStorage.removeItem("loggedOutForInterviewBooking");
    }
  }, [auth.role, location.pathname, navigate]);

  useEffect(() => {
    let mediumSignup = localStorage.getItem("medium-signup")
    if (mediumSignup == "medium-signup") {
      console.log(mediumSignup, "mediumSignup")
      logoutUser();
    }
    else {
      localStorage.removeItem("medium-signup")
    }

  }, [localStorage])

  useEffect(() => {
    let sendBack = localStorage.getItem("sendBack")
    if (auth.role == "client" && sendBack) {
      localStorage.removeItem("sendBack")
      window.open(`${process.env.REACT_APP_API_URL_EXPORT}starter-intro/${id}`, '_self');
    }
  }, [auth.role,])

  // A medium who followed the Onboarding Session link and had to log in first gets sent
  // back to it here, once the role is known. This lives in App rather than in the login
  // page because dispatch(setUpAuth()) swaps the route tree - and unmounts the login
  // page - before the profile call returns.
  useEffect(() => {
    const onboardingHost = localStorage.getItem(ONBOARDING_HOST_STORAGE_KEY);
    if (!onboardingHost || auth.role !== "medium") {
      return;
    }

    const onOnboardingPath =
      location.pathname.startsWith("/onboarding-booking/") ||
      location.pathname === "/booking";

    if (!onOnboardingPath) {
      navigate(`/onboarding-booking/${onboardingHost}`, { replace: true });
    }
  }, [auth.role, location.pathname])

  // Bootstrap backdrops live on <body> and are only cleaned up by .modal("hide") on the
  // modal element. Anything that unmounts a modal first strands the backdrop: a full-screen
  // grey layer that eats every click, and on our data-backdrop="static" modals it cannot
  // even be clicked away. Two things do that here - a route change, and renderUserType
  // swapping the whole medium route tree as the profile fields resolve - so both sets of
  // signals are watched. The sweep runs on a short delay so the incoming screen has had a
  // chance to open a modal of its own, and it no-ops while any modal is genuinely open.
  useEffect(() => {
    const timer = setTimeout(() => {
      clearOrphanModalBackdrops();
    }, MODAL_BACKDROP_SWEEP_DELAY_MS);

    return () => clearTimeout(timer);
  }, [
    location.pathname,
    location.search,
    auth.role,
    status,
    medium_status,
    onboarding_completed,
    provider,
  ]);
  //logout user
  const moveRoute = (url = "/registration") => {
    navigate(url);
    const preservedKeys = ["availabilityNoteClosedAt"]; // Keys to preserve

    const preserveValues = preservedKeys.reduce((acc, key) => {
      const value = localStorage.getItem(key);
      if (value) acc[key] = value;
      return acc;
    }, {});
    localStorage.clear();
    Object.entries(preserveValues).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    window.location.reload();
    dispatch(setUpAuthTrue());
  };
  const logoutUser = (url) => {
    console.log(url)
    //   let url = "/thanks";
    changeOnlineStatusFunc(0, dispatch);
    // dispatch(setLoading(true));
    logout()
      .then((data) => {
        // dispatch(setLoading(false));
        // if (data.data.status) {
        console.log(url)
        moveRoute(url);
        localStorage.removeItem("medium-signup")
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete("redirect_to");
        window.history.replaceState({}, document.title, newUrl.href);
        // }

      })
      .catch((err) => {
        // dispatch(setLoading(false));
        console.log(err);
      });
  };

  useEffect(() => {
    //
    if (currentPathname === '/appointment') {
      history.listen((newLocation, action) => {
        if (action === "PUSH") {
          if (
            newLocation.pathname !== currentPathname ||
            newLocation.search !== currentSearch
          ) {
            // Save new location
            currentPathname = newLocation.pathname;
            currentSearch = newLocation.search;

            // Clone location object and push it to history
            history.history.push({
              pathname: newLocation.pathname,
              search: newLocation.search
            });
          }
        } else {
          // Send user back if they try to navigate back
          history.go(1);
        }
      });
    }

    //


    underMaintenanceStatus();
    clearLocalStorage();
    dispatch(setCredentials());
    if (!auth.auth && status === undefined) callProfile();
  }, []);

  // useEffect(() => {
  //   updateTimezones();
  // }, []);

  //handlers
  const updateTimezones = () => {
    getTimezones()
      .then((data) => {
        if (data.data.status) {
          let items = data.data.data;
          setnewTimezoneData(items);
        }
      })
      .catch((err) => console.log(err));
  };
  // useEffect(() => {

  //   if (timezone !== "" && newTimezoneData.length > 0) {


  //     console.log('start')
  //     console.log(moment.tz.guess(), "moment.tz.guess()");
  //     console.log(newTimezoneData, "newTimezoneData");
  //     console.log(timezone, "timezone")


  //     let items = newTimezoneData.filter((item) => {
  //       if (item.front_name === timezone)
  //         return item;
  //     })
  //     console.log(items, "items")
  //     if (items.length == 1 && items[0].status === 0) {
  //       window.loadModal2("#updateTimeZoneId", "show");
  //     }
  //     else {
  //       window.loadModal2("#updateTimeZoneId", "hide");
  //     }
  //     if (items.length > 1 && checkTime(items, timezone_id)) {
  //       window.loadModal2("#updateTimeZoneId", "show");
  //     }
  //     else {
  //       window.loadModal2("#updateTimeZoneId", "hide");
  //     }

  //   }

  // }, [newTimezoneData, timezone])

  // const checkTime = (items, timezone_id) => {
  //   let time = items.filter((item) => {
  //     if (item.id == parseInt(timezone_id)) {
  //       return item;
  //     }
  //   })
  //   if (time[0].status == 1) {
  //     return false
  //   }
  //   else {
  //     return true
  //   }

  // }
  useEffect(() => {


    if (banner_display === 1) {
      window.loadModal2("#alertPopup", "show");
    }
    let user_status = medium_status;
    let firstName = first_name;
    // setTimeout(() => {


    if (auth.role === "client" && user_status === 1 && (timezone === "" || timezone === null)) {
      {

        window.loadModal2("#checkTimeZone", "show");
      }
    }
    else {
      window.loadModal2("#checkTimeZone", "hide");
    }
    if (
      (auth.role === "medium" &&
        status === 1 &&
        user_status === 1 &&
        provider === "Zoom" && (timezone === "" || timezone === null))
    ) {
      window.loadModal2("#checkTimeZone", "show");
    }
    else {
      window.loadModal2("#checkTimeZone", "hide");
    }
    // }, 2000);

  }, [auth.role !== "", timezone])
  const clearLocalStorage = () => {
    let local_state_user = localStorage.getItem("user");
    let local_state_medium_status = localStorage.getItem("medium_status");
    let local_state_status = localStorage.getItem("status");
    let local_state_role = localStorage.getItem("role");
    if (
      local_state_user !== null ||
      local_state_medium_status !== null ||
      local_state_status !== null ||
      local_state_role !== null
    ) {
      // ONBOARDING_HOST_STORAGE_KEY survives so a pending Onboarding Session link is not
      // lost when this legacy cleanup wipes storage and reloads mid flow.
      const preservedKeys = ["availabilityNoteClosedAt", ONBOARDING_HOST_STORAGE_KEY]; // Keys to preserve

      const preserveValues = preservedKeys.reduce((acc, key) => {
        const value = localStorage.getItem(key);
        if (value) acc[key] = value;
        return acc;
      }, {});
      localStorage.clear();
      Object.entries(preserveValues).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      window.location.reload();
    }
  };
  useEffect(() => {
    if (auth.role === "admin") {
      getRequests();
    }
  }, [auth]);

  // Listen for timezone changes from other tabs/windows
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'userTimezone' && e.newValue) {
        try {
          const updatedUser = JSON.parse(e.newValue);
          dispatch(setUser(updatedUser));
        } catch (error) {
          console.error('Error parsing timezone update from localStorage:', error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [dispatch]);
  const getRequests = () => {
    // getAllRequests()
    //   .then((data) => {
    //     if (data.data.status) {
    //       ADMIN.map((item) => {
    //         if (item.name === "Requests" && data.data.data.length > 0) {
    //           item.count = data.data.data.length;
    //         }
    //       });
    //     }
    //   })
    //   .catch(() => { });
  };
  const callProfile = async (token) => {
    dispatch(setLoading(true));
    await fetchUser(token)
      .then((data) => {
        dispatch(setLoading(false));
        dispatch(setUser(data.data.data));
        // Store user data in localStorage for cross-tab sync
        localStorage.setItem('userTimezone', JSON.stringify(data.data.data));
        renderUserRole(data.data.data.usertype, data.data.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const renderUserRole = (type, users) => {
    const user = userType(type);
    dispatch(setRole(user));
  };
  const renderUserType = (from) => {
   let under_maintenance = process.env.REACT_APP_MANTENANCE_MODE === "true" ? 1 : 0;
    if (under_maintenance === 1) {
      return <Maintenance />
    }
    // let status = localStorage.getItem("status");
    // let user_status = localStorage.getItem("medium_status");
    // console.log(auth);
    // console.log(status, "useruser");
    // console.log(localStorage.getItem("status"), "localStorage.getItem(status)");

    let user_status = medium_status;
    let firstName = first_name;
    
    if (
      auth.role === "medium" &&
      status === 1 &&
      user_status === 1 &&
      (
        onboarding_completed === 1 ||
        from === "onboarding") &&
      provider === "Zoom"
    ) {
      return <Layout children={

        <><MediumRouteApproved />
          <AlertPopUp />
        </>} />;
    }
    //
    else if (
      auth.role === "medium" &&
      status === 1 &&
      user_status === 1 &&
      onboarding_completed === 0
      &&
      from !== "onboarding"
      // (provider === "" || provider === null)
    ) {
      if (id !== 15152) {
        return <MediumOnBoardingRoute />;
      } else {

        return <Layout children={

          <><MediumRouteApproved />
            <AlertPopUp />
          </>} />;
      }

    }
    else if (auth.role === "medium" &&
      status === 1 &&
      user_status === 1 &&

      onboarding_completed === 1 && (provider === "" || provider === null)) {

      if (id !== 15152) {
        return <MediumIntegrationRoute />
      } else {
        return <Layout children={

          <><MediumRouteApproved />
            <AlertPopUp />
          </>} />;
      }

    }
    else if (
      auth.role === "medium" &&
      ((status === 0 && user_status === 0) ||
        (status === 0 && user_status === 1))
    ) {
      return <MediumRoute />;

    } else if (auth.role === "client" && user_status === 1 && firstName != null && firstName != "" && last_name != null && last_name != "" && country != null && country != "" && phone != null && phone != "" && timezone != null && timezone != "" && opt_in_out != null && agree_to_legal_terms_and_conditionss != null) {


      // if (window.location.pathname === "/appointment") {
      //   return <LoggedInRoutes />;
      // }
      // if (window.location.pathname !== "/appointment") {

      if (is_starter === 1 && starter_redirect_url != null && starter_redirect_url != "" && is_questionnaire == 0) {
        window.open(starter_redirect_url, '_self');
      } else {
        return (
          <Layout
            children={
              <>
                <LoggedInRoutes is_first_appointment={is_first_appointment} from={from} />
                <AlertPopUp />
                <Help />
              </>
            }
          />
        );
      }

      // }
    } else if (auth.role === "admin") {
      return <Layout children={<AdminRoutes />} />;
    } else if (auth.role === "client" && (user_status === 0 || firstName == null || firstName == "" || last_name == null || last_name == "" || country == null || country == "" || phone == null || phone == "" || timezone == null || timezone == "" || opt_in_out ==null || agree_to_legal_terms_and_conditionss ==null)) {
      
      return <ClientRoute />;
    } else {
      return (
        <div className="min-height-80vh d-flex align-items-center justify-content-center">
          <div className="">
            <img src="../images/logo-verysoul.png" alt="logo" />
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      {window.location.pathname === "/terms-conditions" ||
        window.location.pathname === "/privacy-policy" ||
        window.location.pathname === "/starter-volunteer-onboarding" ||
         window.location.pathname === "/thank-you-page" ||
         window.location.pathname === "/gift-thank-you" ||
         window.location.pathname === "/special-events" ||
         // VerySoul Gift public pages: same for logged-in and logged-out visitors.
         window.location.pathname === "/redeem" ||
         window.location.pathname.startsWith("/gift-pay/") ||
         window.location.pathname.startsWith("/gift-decision/") ||
         // A medium's profile opened from a gift: same page for logged-in and logged-out recipients.
         (window.location.pathname.startsWith("/profile-view/") && window.location.search.indexOf("from=gift") !== -1) ||

         window.location.pathname === "/payment-cancelled"
        ? (
          <CommonRoute />
        ) : (
          <>
            {auth.auth ? <LoggedOutRoutes /> : renderUserType(from)}
            {auth.isLoading && (
              <div className="spinner">
                <GridLoader size={50} />
              </div>
            )}
            {auth.isLoadingText && (
              <LoaderText text={auth.loadingContent} />
            )}


            <div className="continue ">
              <div className="dont-have-acc display-unset">
                <UpdateTimeZone newTimezoneData={newTimezoneData} />
                <CheckTimeZone />
                <ConfirAdvanceModal />
              </div>
            </div>
          </>
        )}
        <ToastContainer />
      {auth.role !== "admin" &&
        !window.location.pathname.startsWith("/verysoul-verified/") &&
        !window.location.pathname.startsWith("/verysoul-verified-dark/") &&
        !window.location.pathname.startsWith("/verysoul-verified-transparent/") &&
        // Public gift pages carry their own support link in the footer (and
        // /redeem has a floating Continue bar at the bottom).
        window.location.pathname !== "/redeem" &&
        !window.location.pathname.startsWith("/gift-pay/") &&
        !window.location.pathname.startsWith("/gift-decision/") &&
        !(window.location.pathname.startsWith("/profile-view/") && window.location.search.indexOf("from=gift") !== -1) &&
        !(auth.role === "client" && window.innerWidth <= 768) && (
          <SupportIcon
            bottomOffset={
              (hasProgressSection && window.innerWidth >= 768)
                ? "141px"   // push above progress section
                : window.location.pathname === "/register-medium" ||
                  window.location.pathname === "/register-client"
                  ? "90px"   // push above reCAPTCHA
                  : "20px"   // normal position
            }
          />
        )}
    </div>
  );
};

export default App;
